<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-list" />
            <strong>
                {{ $t('people.people') }}
            </strong>
        </b-card-header>
        <b-card-body>
            <div class="pr-2 pl-2">
                <b-row class="d-flex justify-content-end">
                    <b-col md="6">
                        <periods
                            :hideSelectedOptions="false"
                            :numberOfSelectedOptionsToDisplay="3"
                            :closeOnSelect="false"
                            :state="null"
                            :label="$t('targets.showInfoBySelectedPeriods')"
                            :value.sync="selectedPeriods"
                            @ready="filterPeriodsIsReady = $event"
                            @change="updatePageData(true, null, 1)"
                            applyScopeNotArchived
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="mb-2" sm="4" md="2" lg="2" xl="1" order="1">
                        <b-dropdown variant="light" :text="$t('people.actions')" v-if="canViewActionButton">
                            <b-dropdown-item-button v-if="canChangeUsersStageAction" @click="onClickBulkEditHandler">
                                <i class="fas fa-exchange-alt"></i>
                                {{ $t('people.changeUsersStage') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="canAdvanceMassAction" @click="updateManagerDeclare">
                                <i class="fas fa-check-square" />
                                {{ $t('usersAdvanceMass.advanceMass') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="canDownloadUsersAction" @click="onClickDownloadPeople">
                                <i class="fas fa-download" />
                                {{ $t('people.download') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="canUploadsAction" @click="onClickUploadsHandler">
                                <i class="fas fa-upload" />
                                {{ $t('people.uploads') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button
                                v-if="canUpdateUsersNetworkAction"
                                @click="onClickUpdateUsersNetwork"
                            >
                                <i class="fas fa-users" />
                                {{ $t('people.updateUsersNetwork') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button
                                v-if="canUpdateUsersNetworkAction"
                                @click="onClickClearUsersNetwork"
                            >
                                <i class="fas fa-users" />
                                {{ $t('people.clearUsersNetwork') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="canBulkEditingAction" @click="onClickOpenBulkEditingModal">
                                <i class="fas fa-users-cog" />
                                {{ $t('usersBulkEdit.bulkEditing') }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-if="canLinkCommitteesAction" @click="onClickOpenCommitteeModal">
                                <i class="fas fa-users" />
                                {{ $t('people.linkCommittees') }}
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </b-col>
                    <b-col class="mb-2" sm="12" xl="4" order="6" order-xl="2">
                        <b-form-group>
                            <b-form-input
                                v-model="filtered['users.name']"
                                :placeholder="$t('people.searchByName')"
                                @input="onChangeNameFilter"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col class="mb-2" sm="6" md="4" lg="3" xl="2" order="3" order-sm="4">
                        <b-dropdown ref="advancedSearch" variant="light" class="align-self-center">
                            <template #button-content>
                                {{ $t('form.button.filters') }}
                            </template>
                            <b-card no-body>
                                <b-dropdown-form style="max-height: 500px; overflow: auto !important; min-width: 500px">
                                    <stages
                                        v-if="canFilterByStage"
                                        :label="$t('people.filterByStage')"
                                        :placeholder="$t('people.filterByStage')"
                                        :value.sync="filtered['eventUser.event_id']"
                                        :loadDataWhenMounted="true"
                                        @change="updatePageData(true, null, 1)"
                                        @options-loaded="stagesOptions = $event"
                                    />
                                    <managers
                                        :state="null"
                                        :value.sync="filtered['manager_id']"
                                        :disabled="false"
                                        :showLabel="true"
                                        :loadDataWhenMounted="true"
                                        @change="updatePageData(true, null, 1)"
                                        @options-loaded="managersOptions = $event"
                                    />
                                    <sections
                                        :label="$t('form.label.departmentAndUnit')"
                                        :value.sync="selectedSections"
                                        :loadDataWhenMounted="true"
                                        @change="updatePageData(true, null, 1)"
                                        @options-loaded="sectionsOptions = $event"
                                    />
                                    <occupationGroups
                                        :state="null"
                                        :value.sync="filtered['groups.id']"
                                        :disabled="false"
                                        :showLabel="true"
                                        :loadDataWhenMounted="true"
                                        @change="updatePageData(true, null, 1)"
                                        @options-loaded="occupationGroupsOptions = $event"
                                    />
                                    <status
                                        setDefaultStatus
                                        :selected.sync="filtered['status.id']"
                                        @change="updatePageData(true, null, 1)"
                                        @ready="filterStatusIsReady = $event"
                                        @options-loaded="statusOptions = $event"
                                    />
                                    <user-ready-next-stage
                                        v-if="canFilterIsUserReadyToNextStage"
                                        :okUser.sync="filtered['eventUser.ok_user']"
                                        :okManager.sync="filtered['eventUser.ok_manager']"
                                        @change="updatePageData(true, null, 1)"
                                    />
                                    <b-form-group
                                        :label="$t('people.searchByName')"
                                        :description="$t('people.instructions.bulkSearch')"
                                    >
                                        <c-text-area id="bulk-search" :value.sync="bulkSearch" />
                                    </b-form-group>
                                    <div class="text-right">
                                        <b-button :disabled="loaders[lastLoaderKey]" @click="filterByName">
                                            {{ $t('dashboard.search') }}
                                        </b-button>
                                    </div>
                                </b-dropdown-form>
                            </b-card>
                        </b-dropdown>
                    </b-col>
                    <b-col class="mb-2" sm="6" md="3" lg="2" xl="2" order="4">
                        <columns
                            :model.sync="showColumns"
                            :columnsGroups="getColGroups(availableFields)"
                            @change="onChangeShowColumns"
                        />
                    </b-col>
                    <b-col class="mb-2" sm="4" md="3" lg="3" xl="2" order="5" order-sm="2">
                        <filters />
                    </b-col>
                    <b-col class="mb-2" sm="4" md="12" lg="2" xl="1" order-sm="3" order-md="5" order-xl="6">
                        <b-form-group>
                            <b-form-select
                                v-model="pagination.perPage"
                                :options="tableSettings.perPageOptions"
                                @change="updatePageData(false, null, 1)"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <b-table
                hover
                small
                bordered
                show-empty
                responsive
                :items="users"
                class="d-block"
                :busy="loaders[lastLoaderKey]"
                style="overflow-y: auto"
                :fields="tableSettings.fields"
                :empty-text="$t('people.emptyTable')"
                @head-clicked="onClickSortHandler"
            >
                <template #thead-top>
                    <tr>
                        <th
                            v-for="(columnsGroup, index) in colGroups"
                            :key="index"
                            v-show="canSeeColGroup(columnsGroup)"
                            :colspan="canSeeColGroup(columnsGroup)"
                            class="text-center align-middle"
                            :title="columnsGroup.title"
                        >
                            {{ columnsGroup.colGroup }}
                        </th>
                    </tr>
                </template>
                <template #head(_select)>
                    <b-form-checkbox v-model="selectAll" @change="onClickSelectAllHandler" />
                </template>
                <template #head(name)="{ label, column }">
                    <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                </template>
                <template #head(status)="{ label, column }">
                    <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                </template>
                <template #head(unit_goals_achieved)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(department_goals_achieved)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(personal_goals_achieved)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(trigger_goals_achieved)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(unit_goals_amount)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(department_goals_amount)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(personal_goals_amount)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(trigger_goals_amount)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(unit_goals_weight)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(department_goals_weight)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(personal_goals_weight)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(trigger_goals_weight)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>

                <template #head(current_stage)="{ label, column }">
                    <th-with-sort :label="label" :sortDirection="sortedBy[column]" />
                </template>
                <template #head(ok_user)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(ok_manager)="{ label }">
                    <span :title="label">{{ label | shortHeader }}</span>
                </template>
                <template #head(owner_evaluation)="{ label }">
                    <span :title="label">{{ label }}</span>
                </template>
                <template #head(manager_evaluation)="{ label }">
                    <span :title="label">{{ label }}</span>
                </template>
                <template #head(committee_evaluation)="{ label }">
                    <span :title="label">{{ label }}</span>
                </template>
                <template #cell(_select)="{ item }">
                    <b-form-checkbox
                        v-model="selected[item.id].isSelected"
                        @input="
                            () => {
                                updateSelectedUsersCount()
                                updateSelectAllValue()
                            }
                        "
                    />
                </template>
                <template #cell(name)="{ item }">
                    <router-link :to="`/v2/profile/${item.id}`" v-if="canViewUserProfile(item)">
                        <strong>{{ item.name }}</strong>
                    </router-link>
                    <strong v-else>{{ item.name }}</strong>
                </template>
                <template #cell(picture)="{ item }">
                    <router-link :to="canViewUserProfile(item) ? `/v2/profile/${item.id}` : ''">
                        <avatar class="d-inline-block" :src="item.picture" :username="item.name" :size="35" />
                    </router-link>
                </template>
                <template #cell(status)="{ item }">
                    <b-badge
                        :style="{
                            background: item.status_color,
                            color: '#fff',
                        }"
                        pill
                        v-b-popover.hover="item.status_name ? $t('status.' + item.status_name + '.description') : ''"
                    >
                        {{ item.status_name ? $t('status.' + item.status_name + '.name') : '' }}
                    </b-badge>
                </template>
                <template #cell(unit_goals_achieved)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{
                            isGol
                                ? formatPercentageWithSignal(item.unit_goals_multiplier_achieved)
                                : formatPercentageWithSignal(item.unit_goals_achieved)
                        }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(department_goals_achieved)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{
                            isGol
                                ? formatPercentageWithSignal(item.department_goals_multiplier_achieved)
                                : formatPercentageWithSignal(item.department_goals_achieved)
                        }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(personal_goals_achieved)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{
                            isGol
                                ? formatPercentageWithSignal(item.personal_goals_multiplier_achieved)
                                : formatPercentageWithSignal(item.personal_goals_achieved)
                        }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(trigger_goals_achieved)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{
                            isGol
                                ? formatPercentageWithSignal(item.trigger_goals_multiplier_achieved)
                                : formatPercentageWithSignal(item.trigger_goals_achieved)
                        }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(unit_goals_amount)="{ item }">
                    <span v-if="canSeeTargetColumns(item) && item.unit_goals_amount !== null">
                        {{ item.unit_goals_amount }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(department_goals_amount)="{ item }">
                    <span v-if="canSeeTargetColumns(item) && item.department_goals_amount !== null">
                        {{ item.department_goals_amount }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(personal_goals_amount)="{ item }">
                    <span v-if="canSeeTargetColumns(item) && item.personal_goals_amount !== null">
                        {{ item.personal_goals_amount }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(trigger_goals_amount)="{ item }">
                    <span v-if="canSeeTargetColumns(item) && item.trigger_goals_amount !== null">
                        {{ item.trigger_goals_amount }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(unit_goals_weight)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{ formatPercentageWithSignal(item.unit_goals_weight) }}
                    </span>
                </template>
                <template #cell(department_goals_weight)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{ formatPercentageWithSignal(item.department_goals_weight) }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(personal_goals_weight)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{ formatPercentageWithSignal(item.personal_goals_weight) }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(trigger_goals_weight)="{ item }">
                    <span v-if="canSeeTargetColumns(item)">
                        {{ formatPercentageWithSignal(item.trigger_goals_weight) }}
                    </span>
                    <span v-else> - </span>
                </template>
                <template #cell(owner_evaluation)="{ item }">
                    {{ formatPercentageWithSignal(item.owner_evaluation) }}
                </template>
                <template #cell(manager_evaluation)="{ item }">
                    {{ formatPercentageWithSignal(item.manager_evaluation) }}
                </template>
                <template #cell(committee_evaluation)="{ item }">
                    {{ formatPercentageWithSignal(item.committee_evaluation) }}
                </template>
                <template #cell(current_stage)="{ item }">
                    {{ item.current_stage ? item.current_stage : '-' }}
                </template>
                <template #cell(network)="{ item }">
                    <b-button
                        variant="secondary"
                        size="sm"
                        v-if="canSeeUserNetwork(item)"
                        @click="$router.push('/v2/values/valuers/' + item.id)"
                    >
                        {{ $t('people.viewNetwork') }}
                    </b-button>
                    <span v-else>-</span>
                </template>
                <template #cell(released_networks)="{ item }">
                    <span
                        v-if="item.has_value && item.released_networks !== null && item.released_networks !== undefined"
                    >
                        <span v-for="(type, index) in item.released_networks.split(',')" :key="index">
                            {{ $t('values.network.types.' + type) }}
                        </span>
                    </span>
                    <span v-else>-</span>
                </template>
                <template #cell(ok_user)="{ item }">
                    <is-checked-icon :isChecked="item.ok_user" />
                </template>
                <template #cell(ok_manager)="{ item }">
                    <is-checked-icon :isChecked="item.ok_manager" />
                </template>
                <template #table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="align-middle" />
                    </div>
                </template>
                <template #table-caption>
                    <div>
                        <span>
                            {{
                                $t('people.fromToEntries', {
                                    from: pagination.from,
                                    to: pagination.to,
                                    total: pagination.total,
                                })
                            }}
                        </span>
                        <span v-if="selectedUsersCount">
                            {{
                                $t('people.selectedUsers', {
                                    count: selectedUsersCount,
                                })
                            }}
                        </span>
                    </div>
                    <div class="d-flex justify-content-center">
                        <b-pagination
                            class="mb-0"
                            :disabled="loaders[lastLoaderKey]"
                            :total-rows="pagination.total"
                            :per-page="pagination.perPage"
                            v-model="pagination.currentPage"
                            @change="updatePageData(false, null, $event)"
                        />
                    </div>
                </template>
            </b-table>
            <router-view
                :users="getSelectedUsersIDs()"
                :canUploadUsers="canUploadsAction"
                :canChangeUsersStage="canChangeUsersStageAction"
                :canUpdateUsersNetworks="canUpdateUsersNetworkAction"
                @updated="
                    () => {
                        setSelectedUsersStatus(false)
                        updatePageData(false)
                    }
                "
            />
        </b-card-body>
    </b-card>
</template>

<script>
import Vue from 'vue'
import i18n from '@/i18n'
import Swal from 'sweetalert2'
import Avatar from 'vue-avatar'
import api from '@/services/api'
import {
    getUsers,
    getCommittees,
    getTargetsCount,
    getTargetsWeight,
    getNextStageInfo,
    getUsersCurrentStage,
    getTargetsEvaluations,
    getTargetsPerformances,
    getUsersReleasedNetworks,
    getDownloadPeopleFromApi,
} from './api'
import Filters from './components/filters'
import Columns from './components/columns'
import UserReadyNextStage from './components/user-ready-next-stage'
import { groupBy, forEach, sortBy, debounce, filter, uniq, intersection, findIndex } from 'lodash'
import { isCompany } from '@/services/companies-custom-functions'
import ButtonLoader from '@/views/components/button-loader'
import {
    Stages,
    Status,
    Managers,
    CTextArea,
    Departments,
    OccupationGroups,
    SectionsWithoutLevel as Sections,
} from '@/views/components/fields'
import notification from '@/lib/notification'
import { formatNumber, formatPercentage, decimalFormat } from '@/lib/utils'
import { Periods } from '@/views/components/fields'
import { toV1 } from '@/router/routesToV1'
import { userPermissionsMixin } from '@/mixins'
import tableSettings from './constants'
import { noSelectedUsersAlert, onlyAdministratorFunctionAlert, usersWithoutValuesSelectedAlert } from './alerts'

const getters = {
    'user-stage': ({ columns, users }) => getUsersCurrentStage(columns, users),
    'user-next-stage-info': ({ columns, users }) => getNextStageInfo(columns, users),
    'user-networks': ({ columns, users }) => getUsersReleasedNetworks(columns, users),
    'target-count': ({ columns, users, periods }) => getTargetsCount(columns, users, periods),
    'target-weight': ({ columns, users, periods }) => getTargetsWeight(columns, users, periods),
    'target-evaluation': ({ columns, users, periods }) => getTargetsEvaluations(columns, users, periods),
    'target-performance': ({ columns, users, periods }) => getTargetsPerformances(columns, users, periods),
}

const defaultFiltered = {
    'users.name': '',
    manager_id: [],
    'groups.id': [],
    'status.id': [],
    'eventUser.event_id': [],
    'eventUser.ok_user': 0,
    'eventUser.ok_manager': 0,
}

const getRandomValue = () => Math.round(Math.random() * 1000)

notification.init()

Vue.component('th-with-sort', {
    props: ['label', 'sortDirection'],
    computed: {
        sortIcon() {
            return this.sortDirection ? `fa-sort-${this.sortDirection}` : 'fa-sort'
        },
    },
    template: `
        <div class="c-th">
            <span class="mr-1">
                {{ label }}
            </span>
            <i :class="['fa', sortIcon]" />
        </div>
    `,
})

Vue.component('is-checked-icon', {
    props: ['isChecked'],
    template: `
        <i
            v-if="isChecked == 1"
            class="far fa-check-circle fa-lg text-success"
        />
        <i
            v-else-if="isChecked == 0"
            class="far fa-times-circle fa-lg text-danger"
        />
        <span v-else>-</span>
    `,
})

export default {
    name: 'List',
    mixins: [userPermissionsMixin],
    components: {
        Avatar,
        ButtonLoader,
        CTextArea,
        Departments,
        Filters,
        Managers,
        OccupationGroups,
        Periods,
        Sections,
        Stages,
        Status,
        Columns,
        UserReadyNextStage,
    },
    data() {
        return {
            isGol: isCompany('gol') || isCompany('testegol'),
            selected: {},
            selectedUsersCount: 0,
            selectAll: false,
            showColumns: [],
            colGroups: [],
            users: [],
            sortedBy: { column: 'name', name: 'asc' },
            pagination: {
                total: null,
                perPage: 10,
                from: null,
                to: null,
                currentPage: 1,
            },
            tableSettings,
            isLoading: true,
            filtered: { ...defaultFiltered },
            selectedSections: [],
            loaders: {},
            bulkSearch: null,
            selectedPeriods: [],
            committees: [],
            stagesOptions: [],
            statusOptions: [],
            sectionsOptions: [],
            managersOptions: [],
            lastLoaderKey: null,
            globalDebounceCallbacks: [],
            occupationGroupsOptions: [],
            filterStatusIsReady: false,
            filterPeriodsIsReady: false,
        }
    },
    async mounted() {
        const key = getRandomValue()
        this.loaders[key] = true
        this.lastLoaderKey = key

        getCommittees().then((committees) => {
            this.committees = committees
        })

        this.colGroups = this.getColGroups(this.availableFields)
        this.showColumns = filter(this.availableFields, { thClass: '' })

        this.setVuexHandlers()
    },
    methods: {
        onChangeShowColumns(newColumns, oldColumns) {
            if (newColumns.length > oldColumns.length) {
                this.updatePageData()
            }
        },
        onChangeNameFilter() {
            debounce(() => this.updatePageData(true, null, 1), 1000)()
        },
        setVuexHandlers() {
            this.$store.dispatch('setColGroups', this.colGroups)
            this.$store.watch(
                (state) => state.defaultFilters.selectedFilter,
                (selectedFilter) => {
                    if (Object.keys(selectedFilter).length > 0) {
                        this.applyDefaultFilter()
                    }
                }
            )
        },
        getRouteGroupsWithColumns() {
            return uniq(this.selectedColumns.map((item) => item.routeGroup)).reduce((acc, routeGroup) => {
                const columns = this.selectedColumns
                    .filter((item) => item.routeGroup == routeGroup)
                    .map((item) => item.key)
                    .join()
                return {
                    ...acc,
                    [routeGroup]: columns,
                }
            }, {})
        },
        async getData(orderBy, sortedBy, quantityByPage, page, names, filtered) {
            const routeGroupsWithColumns = this.getRouteGroupsWithColumns()

            const key = getRandomValue()
            this.loaders[key] = true
            this.lastLoaderKey = key

            const { to, from, total, users, perPage, currentPage } = await getUsers({
                names,
                orderBy,
                filtered,
                sortedBy,
                currentPage: page,
                perPage: quantityByPage,
                sections: this.sectionsIDs,
                fields: routeGroupsWithColumns['user-info'],
            })

            this.pagination = {
                to,
                from,
                total,
                perPage,
                currentPage,
            }

            if (!users.length) {
                this.users = []
                this.loaders[key] = false
                return
            }

            const ids = []
            const data = users.map((user) => {
                ids.push(user.id)

                const { rated_committees } = user

                return {
                    ...user,
                    currentPage,
                    rated_committees: rated_committees ? rated_committees.split(',').map((i) => parseInt(i)) : [],
                }
            })

            const promises = []
            Object.keys(getters).forEach((key) => {
                if (routeGroupsWithColumns[key]) {
                    const columns = routeGroupsWithColumns[key]
                    const promise = getters[key]({
                        columns,
                        users: ids,
                        periods: this.selectedPeriodsIDs,
                    })
                    promises.push(promise)
                }
            })

            Promise.all(promises)
                .then((results) => {
                    results.forEach((resp) => {
                        resp.forEach((result) => {
                            const i = data.findIndex((user) => user.id == result.user_id)
                            data[i] = {
                                ...data[i],
                                ...result,
                            }
                        })
                    })

                    data.forEach((user) => this.createUserSelecObject(user))
                    this.users = data

                    this.loaders[key] = false
                })
                .catch(() => {
                    this.loaders[key] = false
                })
        },
        getEvaluationValue(value) {
            if (!value) {
                value = '-'
            }
            return value === '-' ? value : this.formatPercentage(value) + '%'
        },
        canSeeTargetColumns(user) {
            const isHimselfUser = user.id == this.currentUser.id
            const isManagerOfuser = user.manager_id == this.currentUser.id
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_target_master']

            return isHimselfUser || isManagerOfuser || this.userHasPermission(this.currentUser, availableRoles, [])
        },
        canViewUserProfile(user) {
            const canSeeManagerProfile = this.canSeeManagerProfile(user)
            const isManagerOfuser = this.currentUser.id == user.manager_id
            const isHimselfUser = this.currentUser.id == user.id
            const hasCommiteePermission = this.hasCommiteePermission(user, 'allow_committee_to_view_evaluated_users')
            const isCommitteEvaluator = this.isCommitteeMember(
                this.currentUser.evaluator_committees,
                user.rated_committees
            )
            return (
                isHimselfUser ||
                isManagerOfuser ||
                canSeeManagerProfile ||
                hasCommiteePermission ||
                this.canCurrentUserSeeProfile ||
                isCommitteEvaluator
            )
        },
        canSeeManagerProfile(user) {
            return user.id == this.currentUser.manager_id && this.currentUser.is_allowed_to_access_manager_profile
        },
        hasCommiteePermission(user, operationTitle) {
            const intersectionCommittees = this.getIntersectionOfUsersCommittees(user)

            const eventPermissions = intersectionCommittees.reduce((acc, committee) => {
                const eventId = this.getCurrentUserEventId()
                const eventPermissions = committee.event_permissions.filter((eventPermission) => {
                    return eventPermission.event_id === eventId && eventPermission.operation.title === operationTitle
                })

                return [...acc, ...eventPermissions]
            }, [])

            return eventPermissions.length > 0
        },
        getIntersectionOfUsersCommittees(user) {
            const userCommitteesIDs = user.rated_committees
            const currentUserCommitteesIDs = this.currentUser.evaluator_committees.map((i) => i.id)

            const intersectionCommitteesIDs = intersection(currentUserCommitteesIDs, userCommitteesIDs)

            const intersectionCommittees = this.committees.filter((i) => intersectionCommitteesIDs.includes(i.id))

            return intersectionCommittees
        },
        getCurrentUserEventId() {
            let currentUserEventId = this.currentUser.event_user ? this.currentUser.event_user.event_id : null

            return currentUserEventId
        },
        updateManagerDeclare(event) {
            event.preventDefault()

            if (!this.selectedUsersCount) {
                return noSelectedUsersAlert()
            }

            Swal.queue([
                {
                    type: 'warning',
                    title: i18n.t('notification.areYouSure'),
                    html: i18n.t('usersAdvanceMass.messages.advancesUsers'),
                    confirmButtonText: i18n.t('notification.yes'),
                    cancelButtonText: i18n.t('notification.no'),
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    preConfirm: () => {
                        let params = {
                            users: this.getSelectedUsersIDs(),
                        }

                        return api
                            .post('users/bulk/update-manager-declare', params)
                            .then(() => {
                                Swal.insertQueueStep({
                                    type: 'success',
                                    title: i18n.t('notification.requestSentSuccessfully'),
                                    text: i18n.t('notification.usersBulkEditRequestSuccessfullySent'),
                                })
                                this.$emit('updated')
                            })
                            .catch((error) => {
                                Swal.insertQueueStep({
                                    title: i18n.t('notification.somethingWentWrong'),
                                    type: 'error',
                                    text: i18n.t('notification.usersAdvanceMassEditRequestFailed'),
                                })
                                console.log(error)
                            })
                    },
                },
            ])
        },
        onClickOpenCommitteeModal() {
            if (!this.selectedUsersCount) {
                return noSelectedUsersAlert()
            }
            this.$router.push({
                path: `/v2/people/list/bind-committee`,
            })
        },
        onClickOpenBulkEditingModal() {
            if (!this.selectedUsersCount) {
                return noSelectedUsersAlert()
            }
            this.$router.push({
                path: '/v2/people/list/bulk-edit',
            })
        },
        filterByName() {
            this.$refs.advancedSearch.hide(true)
            this.updatePageData()
        },
        everySelectedUserHasValues() {
            const usersWithoutValuesIDs = Object.keys(this.selected).filter((key) => {
                return this.selected[key].hasValues == false && this.selected[key].isSelected == true
            })

            return usersWithoutValuesIDs.length ? false : true
        },
        updateSelectedUsersCount() {
            this.selectedUsersCount = this.getSelectedUsersIDs().length
        },
        getSelectedUsersIDs() {
            return Object.keys(this.selected).filter((id) => {
                return this.selected[id].isSelected == true
            })
        },
        formatNumber(number) {
            return formatNumber(number)
        },
        formatPercentageWithSignal(value) {
            if (value === null || value == undefined) {
                return '-'
            }

            return formatPercentage(decimalFormat(value)) + ' %'
        },
        formatPercentage(number) {
            if (number === null) {
                return '-'
            }
            return formatPercentage(decimalFormat(number))
        },
        removeEmptyLinesAndTrim(names) {
            return names.reduce((namesToSearch, name) => {
                const nameTrimmed = name.trim()
                if (nameTrimmed.length) {
                    return [...namesToSearch, nameTrimmed]
                }
                return [...namesToSearch]
            }, [])
        },
        getParsedAdvancedFilters() {
            const advancedFilters = {}
            const properties = {
                string: ['users.name'],
                array: ['eventUser.event_id', 'manager_id', 'status.id', 'groups.id'],
                boolean: ['eventUser.ok_manager', 'eventUser.ok_user'],
            }

            Object.keys(properties).forEach((type) => {
                properties[type].forEach((property) => {
                    if (this.filtered[property]) {
                        if (type == 'array') {
                            advancedFilters[property] = this.filtered[property].map((i) => i.value)
                        } else {
                            advancedFilters[property] = this.filtered[property]
                        }
                    }
                })
            })

            return advancedFilters
        },
        updatePageData(shouldAwait = true, perPage = null, currentPage = null) {
            if (!this.filtersAreReady) {
                return
            }

            perPage = perPage !== null ? perPage : this.pagination.perPage
            currentPage = currentPage !== null ? currentPage : this.pagination.currentPage

            const time = shouldAwait ? 2000 : 0
            const { column } = this.sortedBy
            const advancedFilters = this.getParsedAdvancedFilters()

            const callbackDebounce = () => {
                this.getData(
                    column,
                    this.sortedBy[column],
                    perPage,
                    currentPage,
                    this.advancedSearchNamesArray,
                    advancedFilters
                )
            }

            this.globalDebounceCallbacks.push(callbackDebounce)
            this.resolveDebounce(time)
        },
        resolveDebounce(time) {
            if (this.globalDebounceCallbacks.length) {
                const lastCallback = this.globalDebounceCallbacks.pop()
                this.globalDebounceCallbacks = []
                debounce(() => {
                    lastCallback()
                }, time)()
            }
        },
        onClickBulkEditHandler() {
            return this.$router.push({
                path: '/v2/people/list/users-stages-administration',
            })
        },
        usersWithoutValuesSelectedAlert() {
            const usersNames = Object.keys(this.selected)
                .filter((key) => {
                    return this.selected[key].isSelected && !this.selected[key].hasValues
                })
                .map((key) => {
                    return this.selected[key].name
                })

            usersWithoutValuesSelectedAlert(usersNames)
        },
        onClickUpdateUsersNetwork() {
            if (!this.selectedUsersCount) {
                noSelectedUsersAlert()
                return
            }

            if (!this.everySelectedUserHasValues()) {
                this.usersWithoutValuesSelectedAlert()
                return
            }

            this.$router.push({
                path: '/v2/people/list/update-users-networks',
            })
        },
        onClickClearUsersNetwork() {
            this.$router.push({
                path: 'list/clear-users-network',
            })
        },
        onClickUploadsHandler() {
            if (this.canUploadsAction) {
                this.$router.push({
                    path: '/v2/people/list/uploads',
                })
            } else {
                this.onlyAdministratorFunction()
            }
        },
        onClickDownloadPeople() {
            if (this.canDownloadUsersAction) {
                Swal.queue([
                    {
                        title: i18n.t('notification.doYouWantToDownloadUsers'),
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: i18n.t('notification.yes'),
                        cancelButtonText: i18n.t('notification.cancel'),
                        showLoaderOnConfirm: true,
                        allowOutsideClick: false,
                        preConfirm: () => {
                            return getDownloadPeopleFromApi(
                                this.filtered,
                                this.getPeriodsIds(),
                                this.getSelectedUsersIDs()
                            ).then(() => {
                                Swal.insertQueueStep({
                                    type: 'success',
                                    title: i18n.t('notification.requestSentSuccessfully'),
                                    text: i18n.t('notification.youWillReceiveAnEmailWithTheDownloadFile'),
                                })
                            })
                        },
                    },
                ])
            } else {
                this.onlyAdministratorFunction()
            }
        },
        onlyAdministratorFunction() {
            return onlyAdministratorFunctionAlert()
        },
        onClickSelectAllHandler(isSelected) {
            this.users.map((user) => {
                if (user.currentPage == this.pagination.currentPage) {
                    this.selected[user.id] = {
                        name: user.name,
                        isSelected,
                        hasValues: user.has_value,
                    }
                }
            })

            this.selectAll = true
            this.updateSelectedUsersCount()
        },
        onClickSortHandler(columnName) {
            if (!this.tableSettings.columnsAllowedToSortedBy.includes(columnName)) {
                return false
            }

            this.sortedBy = {
                ...this.sortedBy,
                [columnName]: this.sortedBy[columnName] === 'asc' ? 'desc' : 'asc',
                column: columnName,
            }

            this.updatePageData(false)
        },
        createUserSelecObject(user) {
            const hasKey = this.selected.hasOwnProperty(user.id)
            if (!hasKey) {
                this.selected[user.id] = {
                    name: user.name,
                    isSelected: false,
                    hasValues: user.has_value,
                }
            }
        },
        getColGroups(fields) {
            fields = sortBy(fields, [
                function (field) {
                    return field.order
                },
            ])

            const colGroupFields = groupBy(fields, 'colGroup')
            let colGroup = []

            forEach(colGroupFields, function (itens, key) {
                let colGroupObj = {
                    colGroup: key,
                    columns: itens,
                    title: itens[0].title,
                }
                colGroup.push(colGroupObj)
            })
            return colGroup
        },
        getCheckboxOptions(columns) {
            return columns.map((column) => {
                return {
                    text: column.label,
                    value: column,
                }
            })
        },
        setSelectedUsersStatus(isSelected) {
            Object.keys(this.selected).map((key) => {
                this.selected[key].isSelected = isSelected
            })
        },
        getPeriodsIds() {
            return this.selectedPeriods.map((period) => period.value)
        },
        toV1(path, id) {
            return toV1(path, { userId: id })
        },
        canSeeUserNetwork(user) {
            const isManagerOfuser = this.currentUser.id == user.manager_id
            const isHimselfUser = this.currentUser.id == user.id
            const hasCommiteePermission = this.hasCommiteePermission(
                user,
                'allow_committee_to_view_evaluated_users_networks'
            )
            return (
                user.has_value &&
                (isHimselfUser ||
                    hasCommiteePermission ||
                    isManagerOfuser ||
                    this.canCurrentUserSeeUserNetwork ||
                    this.currentUser.is_values_master)
            )
        },
        resetFilters() {
            this.showColumns = []
            this.pagination.perPage = 10
            this.pagination.currentPage = 1
            this.selectedPeriods = []
            this.selectedSections = []
            this.filtered = { ...defaultFiltered }
        },
        applyDefaultFilter() {
            this.resetFilters()
            const filter = this.$store.state.defaultFilters.selectedFilter
            if (Object.keys(filter).length === 0) {
                return
            }
            this.showColumns = this.mapColumns(filter.columns)
            this.pagination.perPage = filter.per_page
            this.pagination.currentPage = 1
            this.selectedPeriods = this.mapDefaultFilterPeriods()

            if (filter.advanced_search_fields !== null && filter.advanced_search_fields !== undefined) {
                this.mapAdvancedFields(filter.advanced_search_fields)
            } else {
                this.bulkSearch = ''
                this.filtered = { ...defaultFiltered }
            }

            this.updatePageData(false)
        },
        mapColumns(columns) {
            let cols = []
            const availableFields = this.getColGroups(this.availableFields)
            availableFields.forEach((element) => {
                cols = cols.concat(element.columns.filter((el) => columns.map((item) => item.key).includes(el.key)))
            })
            return cols
        },
        mapAdvancedFields({ names, filter, sections }) {
            this.bulkSearch = this.mapNames(names)
            this.filtered = this.mapFilter(filter)
            this.selectedSections = this.mapSections(sections)
        },
        mapNames(names) {
            return names.toString().replace(/,/g, '\n')
        },
        mapFilter(filter) {
            const parsedFiltered = {}
            const filtersOptions = {
                'status.id': this.statusOptions,
                manager_id: this.managersOptions,
                'eventUser.event_id': this.stagesOptions,
                'groups.id': this.occupationGroupsOptions,
            }
            const arrayProperties = Object.keys(filtersOptions)

            Object.entries(filter).forEach(([key, value]) => {
                if (arrayProperties.includes(key)) {
                    parsedFiltered[key] = value.map((id) => filtersOptions[key].find((option) => option.value == id))
                } else {
                    parsedFiltered[key] = !!value
                }
            })
            return parsedFiltered
        },
        mapSections(sections) {
            return sections.map((id) => this.sectionsOptions.find((option) => option.value == id))
        },
        canSeeColGroup(columnsGroup) {
            return columnsGroup.columns.length
        },
        mapDefaultFilterPeriods() {
            return this.$store.state.defaultFilters.selectedFilter.periods.map((element) => {
                const keys = Object.keys(element)
                const keysMapped = keys.map((item) => this.parseCamelCase(item))
                const obj = {}
                for (let i = 0; i < keys.length; i++) {
                    obj[keysMapped[i]] = element[keys[i]]
                }
                return obj
            })
        },
        parseCamelCase(str) {
            const parseNames = {
                name: 'label',
                id: 'value',
            }

            if (Object.keys(parseNames).includes(str.toLowerCase())) {
                str = parseNames[str.toLowerCase()]
            }
            return str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
        },
        updateSelectAllValue() {
            this.selectAll = this.users.every((user) => {
                return this.selected[user.id].isSelected == true && user.currentPage == this.pagination.currentPage
            })
        },
        canSeeValuesFieldsByCommitteePermission(field) {
            if (field.key != 'network' && field.key != 'released_networks') {
                return false
            }

            if (!this.currentUser.has_modules.includes('has_value')) {
                return false
            }

            const committeeEventsPermissions = this.currentUser.evaluator_committees.map((committee) => {
                return committee.event_permissions.map((eventPermission) => {
                    return eventPermission.operation.title
                })
            })

            if (!committeeEventsPermissions.length) {
                return false
            }

            const allowCommitteeToViewEvaluatedUsersNetworksKey = 'allow_committee_to_view_evaluated_users_networks'

            const committeePermission = committeeEventsPermissions.reduce((permission) => permission)

            const allowCommiteeToViewValuesFields = committeePermission.find(
                (permission) => permission == allowCommitteeToViewEvaluatedUsersNetworksKey
            )

            return allowCommiteeToViewValuesFields !== undefined
        },
    },
    computed: {
        advancedSearchNamesArray() {
            if (Array.isArray(this.bulkSearch)) {
                return this.bulkSearch
            }
            if (!this.bulkSearch) {
                return []
            }

            const newLineSplit = this.bulkSearch.split('\n')
            if (newLineSplit) {
                return this.removeEmptyLinesAndTrim(newLineSplit)
            }

            return []
        },
        sectionsIDs() {
            return this.selectedSections.map((section) => section.value)
        },
        selectedPeriodsIDs() {
            return this.selectedPeriods.map((i) => i.value)
        },
        availableFields() {
            return filter(this.tableSettings.fields, (field) => {
                const userPermissionFields = this.userHasPermission(this.currentUser, field.roles, field.modules)

                const canSeeValuesFieldsByCommitteePermission = this.canSeeValuesFieldsByCommitteePermission(field)

                return userPermissionFields || canSeeValuesFieldsByCommitteePermission
            })
        },
        canCurrentUserSeeProfile() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_values_master',
                'is_target_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canCurrentUserSeeUserNetwork() {
            const availableModules = ['has_value']
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_values_master']
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canFilterIsUserReadyToNextStage() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_manager',
                'is_values_master',
                'is_target_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canFilterByStage() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_manager',
                'is_values_master',
                'is_target_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canAdvanceMassAction() {
            const availableModules = ['has_goal', 'has_kpi', 'has_value']
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_manager']
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canLinkCommitteesAction() {
            const availableModules = ['has_goal', 'has_kpi', 'has_value']
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_values_master']
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canBulkEditingAction() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_values_master',
                'is_target_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canUpdateUsersNetworkAction() {
            const availableModules = ['has_value']
            const availableRoles = ['god', 'administrator', 'local_administrator', 'is_values_master']
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canUploadsAction() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_target_master',
                'is_values_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules, true)
        },
        canDownloadUsersAction() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_target_master',
                'is_values_master',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canChangeUsersStageAction() {
            const availableModules = ['has_goal', 'has_kpi', 'has_value']
            const availableRoles = [
                'god',
                'administrator',
                'is_target_master',
                'is_values_master',
                'local_administrator',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        canViewActionButton() {
            const availableModules = []
            const availableRoles = [
                'god',
                'administrator',
                'local_administrator',
                'is_target_master',
                'is_values_master',
                'is_manager',
            ]
            return this.userHasPermission(this.currentUser, availableRoles, availableModules)
        },
        currentUser() {
            return this.$store.state.currentUser.user
        },
        selectedColumns() {
            return this.showColumns.filter((field) => field.thClass == '' && field.tdClass == '')
        },
        filtersAreReady() {
            return this.filterStatusIsReady && this.filterPeriodsIsReady
        },
    },
    watch: {
        filtersAreReady: function () {
            if (this.filtersAreReady) {
                this.updatePageData(false)
            }
        },
        users: function () {
            this.updateSelectAllValue()
        },
        pagination: function () {
            this.updateSelectAllValue()
        },
        selectedPeriods: function () {
            this.setSelectedUsersStatus(false)
        },
        selectedSections: function () {
            this.setSelectedUsersStatus(false)
        },
        filtered: {
            handler: function () {
                this.setSelectedUsersStatus(false)
            },
            deep: true,
        },
        showColumns(newColumns) {
            const fields = this.tableSettings.fields

            /**
             * Set which field must be showed
             */
            forEach(fields, function (element, index) {
                let isShow = findIndex(newColumns, (column) => {
                    return column.key == element.key
                })
                if (isShow < 0) {
                    fields[index].thClass = 'd-none'
                    fields[index].tdClass = 'd-none'
                } else {
                    fields[index].thClass = ''
                    fields[index].tdClass = ''
                }
            })

            this.colGroups = this.getColGroups(newColumns)
        },
    },
    filters: {
        shortHeader: function (value) {
            if (!value) return ''
            value = value.toString()

            return value.substring(0, 3) + '.'
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';
.c-th:hover {
    cursor: pointer;
}

@media (max-width: 575px) {
    .btn-xs-block {
        width: 100%;
    }
}
</style>
